import React from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { Analytics as VercelAnalytics } from '@vercel/analytics/react';
import { App as AntdApp } from 'antd';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import 'react-phone-input-2/lib/style.css';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'src/styles/main.scss';
import ScrollToTop from 'utils/ScrollToTop';

import { store } from 'store';

import App from './app';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';

const AppProviders = ({ children }: { children: React.ReactNode }) => {
  if (!googleClientId) {
    return <>{children}</>;
  }

  return <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AppProviders>
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
      <CookiesProvider>
        <Provider store={store}>
          <BrowserRouter>
            <ScrollToTop />
            <AntdApp>
              <App />
              <VercelAnalytics />
            </AntdApp>
          </BrowserRouter>
        </Provider>
      </CookiesProvider>
    </GoogleReCaptchaProvider>
  </AppProviders>,
);
